import styles from './SubscribeForm.module.css'

export const PhnxSubscribeForm = ({ placeholder }: { placeholder?: string }) => {
  return (
    <div className={styles['subscribeForm']}>
      <input
        className={styles['subscribeInput']}
        type="text"
        name="email"
        placeholder={placeholder ?? 'Email address'}
      />
      <button className={styles['subscribeCta']} type="submit">
        Subscribe
      </button>
    </div>
  )
}
